import React from 'react';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaArrowRight, FaMapMarkerAlt, FaHeadset } from 'react-icons/fa';
import useScrollAnimation from './useScrollAnimation';

const ctaCards = [
  {
    id: 'i18-pro',
    title: 'Peace i18 PRO (5G)',
    tagline: 'Beyond Power. Beyond Limits.',
    badge: '5G Flagship',
    specText: '6.61" FHD+ 120Hz • 20MP AI Rear • 5000 mAh • 128GB Storage',
    btnText: 'View i18 PRO Details',
    image: '/Photo/i17-pro-hero.png',
    btnClass: 'apple-btn-primary',
    warranty: '1 Year Warranty • Peace Certified'
  },
  {
    id: 'nova-17-pro',
    title: 'Peace NOVA 18 PRO',
    tagline: 'The Ultimate Smartphone Experience',
    badge: '50MP Camera',
    specText: '50MP Rear • 6.56" HD+ • 5000 mAh • 4GB+64GB (Exp. to 128GB)',
    btnText: 'View NOVA 18 Details',
    image: '/Photo/nova-17-pro-hero.jpg',
    btnClass: 'apple-btn-primary',
    warranty: '1 Year Warranty • 3 Color Finishes'
  },
  {
    id: 'sc26',
    title: 'Peace SC26 (Aura26)',
    tagline: 'Performance Meets Peace.',
    badge: 'Built-in Stylus Pen',
    specText: 'Built-in Stylus • 6.56" HD+ • 5000 mAh • 4GB+128GB / 6GB+64GB',
    btnText: 'View SC26 Details',
    image: '/Photo/sc26-hero.jpg',
    btnClass: 'apple-btn-primary',
    warranty: '1 Year Warranty (Peace of Mind)'
  }
];

const CallToAction = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.15 });

  return (
    <section 
      ref={sectionRef} 
      className={`cta-section ${isVisible ? 'is-visible' : ''}`}
      id="explore"
    >
      <div className="section-container">
        {/* Main Header */}
        <div className="text-center cta-section-header scroll-fade-up">
          <span className="section-eyebrow">Product Catalog</span>
          <h2 className="cta-title">Explore the 2026 Smartphone Lineup.</h2>
          <p className="cta-subtitle">
            Every Peace smartphone is crafted for reliability and backed by our official 1-Year manufacturer warranty.
          </p>
        </div>

        {/* 3 Model Cards Row */}
        <div className="cta-cards-row scroll-scale-up">
          {ctaCards.map((card) => (
            <div key={card.id} className="cta-model-card">
              <div className="cta-card-badge">{card.badge}</div>
              <div className="cta-card-img-box">
                <img src={card.image} alt={card.title} className="cta-card-img" />
              </div>
              <h3 className="cta-card-title">{card.title}</h3>
              <p className="cta-card-tagline">{card.tagline}</p>
              <div className="cta-card-specs">{card.specText}</div>
              <div className="cta-card-warranty">{card.warranty}</div>
              <Link to={`/products/${card.id}`} className={`apple-btn ${card.btnClass} full-width mt-3`}>
                {card.btnText} <FaArrowRight className="btn-icon-right ms-2" />
              </Link>
            </div>
          ))}
        </div>

        {/* Value Props & Dealer Support Bar */}
        <div className="cta-perks-grid scroll-fade-up mt-5">
          <div className="cta-perk-item">
            <div className="perk-icon-wrap">
              <FaShieldAlt />
            </div>
            <div className="perk-text">
              <strong>1-Year Peace Warranty</strong>
              <span>Full hardware coverage and genuine parts support</span>
            </div>
          </div>

          <div className="cta-perk-item">
            <div className="perk-icon-wrap">
              <FaMapMarkerAlt />
            </div>
            <div className="perk-text">
              <strong>Authorized Service Centres</strong>
              <span>Nationwide repair network & expert technicians</span>
            </div>
          </div>

          <div className="cta-perk-item">
            <div className="perk-icon-wrap">
              <FaHeadset />
            </div>
            <div className="perk-text">
              <strong>Dedicated Customer Support</strong>
              <span>Friendly helpdesk and warranty verification</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
